import { render, staticRenderFns } from "./IconUploadPortfolio.vue?vue&type=template&id=79e96583&"
import script from "./IconUploadPortfolio.vue?vue&type=script&lang=js&"
export * from "./IconUploadPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports